const mui = {
  MuiTabs: {
    defaultProps: {
      indicatorColor: "transparent",
      textColor: "primary",
    },
    styleOverrides: {
      root: ({ theme }) => ({
        borderRight: `1px solid ${theme.palette.background.paper}`,
        borderLeft: `1px solid ${theme.palette.background.paper}`,
        backgroundColor: theme.palette.background.group,
        "& .Mui-selected": {
          backgroundColor: theme.palette.background.default,
        },
      }),
    },
  },
};
export default mui;
